<script>
	import LazyImg from "./LazyImg.svelte";

	export let id;
	export let src = undefined;
	export let srcMobile = undefined;
	export let srcTablet = undefined;
	export let srcDesktop = undefined;
	export let styleMobile = "";
	export let styleTablet = "";
	export let styleDesktop = "";
	export let hideOn = [];

	$: cssClass = $$props.class || "";
	$: cssStyle = $$props.style || "";

	$: noDifferences =
		srcMobile === srcTablet &&
		srcTablet === srcDesktop &&
		styleMobile === styleTablet &&
		styleTablet === styleDesktop &&
    (!Array.isArray(hideOn) || !hideOn.length);

  function fixStyle(s) {
    return s
      .replace('width: undefined;', '')
      .replace('width:undefined;', '')
      .replace('height: undefined;', '')
      .replace('height:undefined;', '')
  }

</script>

<div class="lazy-img-responsive" {id}>
	{#if noDifferences}
		{#if src || srcDesktop}
			<LazyImg {id} class="{cssClass} lazy-img-responsive" style="{cssStyle} {styleDesktop}" src={srcDesktop || src} />
		{/if}
	{:else}
		{#if !hideOn.includes("desktop") && (src || srcDesktop)}
			<LazyImg
				id="{id}_desktop"
				class="{cssClass} lazy-img-responsive-desktop"
				style="{fixStyle(cssStyle)} {fixStyle(styleDesktop)}"
				src={srcDesktop || src}
			/>
		{/if}
		{#if !hideOn.includes("tablet") && (src || srcTablet)}
			<LazyImg
				id="{id}_tablet"
				class="{cssClass} lazy-img-responsive-tablet"
				style="{fixStyle(cssStyle)} {fixStyle(styleTablet)}"
				src={srcTablet || src}
			/>
		{/if}
		{#if !hideOn.includes("mobile") && (src || srcMobile)}
			<LazyImg
				id="{id}_mobile"
				class="{cssClass} lazy-img-responsive-mobile"
				style="{fixStyle(cssStyle)} {fixStyle(styleMobile)}"
				src={srcMobile || src}
			/>
		{/if}
	{/if}
</div>

<style lang="scss">
	:global(.lazy-img-responsive-desktop) {
		@media (max-width: $breakpoint-tablet) {
			display: none !important;
		}
	}

	:global(.lazy-img-responsive-tablet) {
		@media (max-width: $breakpoint-mobile),
		(min-width: #{$breakpoint-tablet + 1px}) {
			display: none !important;
		}
	}

	:global(.lazy-img-responsive-mobile) {
		@media (min-width: #{$breakpoint-mobile + 1px}) {
			display: none !important;
		}
	}
</style>
